import {Sorting} from "@elastic/react-search-ui";
import SortLayout from "./SortLayout";
type PageProps = {
    sortOptions: any,
    defaultSortOrder: any
};

const sort = ({ sortOptions, defaultSortOrder }: PageProps) => {
    return (
        <Sorting label="Sort by:" sortOptions={sortOptions} view={({ onChange, options, label, value }) => {
            return <SortLayout onChange={onChange} options={options} label={label} value={value === '|||' ? defaultSortOrder : value} defaultSortOrder={defaultSortOrder} />
        }} />
    )
}

export default sort;
